import { BehaviorSubject } from 'rxjs';
import { Dispatch, SetStateAction } from 'react';

const initialState = '';

const state$ = new BehaviorSubject<string>(initialState);

const setState = (data: string) => {
  return state$.next(data);
};

const PartHighlightService = {
  highlightPart: (partId: string) => {
    setState(partId);
  },

  getState: (setHighlightedPart: Dispatch<SetStateAction<string>>) => {
    return state$.asObservable().subscribe((next) => setHighlightedPart(next));
  },
};

export default PartHighlightService;
